/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FiDownload, FiEye } from "react-icons/fi";

export function ActionsColumnFormatter(
  cellContent,
  row,
  rowIndex,
  {
    abrirModalDetalhe,
    abrirModalDownloadDetalhe
  }
) {
  return (
    <div className="flex space-x-2 justify-center">
      {row && (
        <div className="flex space-x-2 justify-center">
          <OverlayTrigger overlay={<Tooltip className="bg-gray-500 text-white py-1 px-2 rounded-md text-sm font-medium">Visualizar Fatura</Tooltip>}>
            <FiEye
              className="w-4 h-4 text-[#71717A] hover:text-gray-500 cursor-pointer"
              onClick={() => {
                abrirModalDetalhe(row);
              }}
            />
          </OverlayTrigger>
          <OverlayTrigger overlay={<Tooltip className="bg-gray-500 text-white py-1 px-2 rounded-md text-sm font-medium">Download Fatura</Tooltip>}>
            <FiDownload
              className="w-4 h-4 text-[#71717A] hover:text-gray-500 cursor-pointer"
              // onClick={() => window.open(row.pathCloud, "_blank")}
              onClick={() => {
                abrirModalDownloadDetalhe(row);
              }}
            />
          </OverlayTrigger>
        </div>
      )}
    </div>
  )
}
